import { umComment, errors } from '@services';

export default {
	namespaced: true,
	state: {
		pageDataList: [
			{
				label: '待审核',
				key: 'audit',
				params: {
					check: 0,
					pageNum: 1,
					pageSize: 10,
				},
				listInfo: {
					records: [],
					total: 0,
				},
			},
			{
				label: '已通过',
				key: 'pass',
				params: {
					check: 2,
					pageNum: 1,
					pageSize: 10,
				},
				listInfo: {
					records: [],
					total: 0,
				},
			},
			{
				label: '已删除',
				key: 'delete',
				params: {
					check: 1,
					pageNum: 1,
					pageSize: 10,
				},
				listInfo: {
					records: [],
					total: 0,
				},
			},
			// {
			// 	label: '已禁言',
			// 	key: 'muted',
			// 	params: {
			// 		check: '',
			// 		pageNum: 1,
			// 		pageSize: 10,
			// 	},
			// 	listInfo: {
			// 		records: [],
			// 		total: 0,
			// 	}
			// },
		],
	},
	mutations: {
		setPageNum(state, payload) {
			const { index, pageNum } = payload;
			state.pageDataList[index].params.pageNum = pageNum;
		},
		setPageData(state, payload) {
			const { index, data } = payload;
			state.pageDataList[index].listInfo.records = data;
		},
	},
	actions: {
		getListByItemIndex({ state }, index, baseParams = {}) {
			const target = state.pageDataList[index];
			umComment
				.getList({
					...baseParams,
					...target.params,
				})
				.then(({ ok, data }) => {
					if (ok) {
						state.pageDataList[index].listInfo = data.data;
					}
				})
				.catch((err) => {
					errors(err);
				});
		},
	},
};
